// select-another-default-method.component.ts
import { Component, Inject } from '@angular/core';
import { PaypointService } from '../../../services/paypoint.service';
import { PaymentMethodResponse } from '../../../models/payment-method-response.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LayoutUtility } from '../../../../../shared/utils';

@Component({
  selector: 'kt-bridgepay-remove-confirmation-dialog',
  templateUrl: './remove-confirmation-dialog.component.html',
  styleUrls: ['./remove-confirmation-dialog.component.scss'],
})
export class RemoveConfirmationDialogComponent {
  constructor(
    private paypointService: PaypointService,
    private layoutUtility: LayoutUtility,
    public dialogRef: MatDialogRef<RemoveConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      organization: string;
      customerId: string;
      method: PaymentMethodResponse;
      newDefaultCardSelected?: PaymentMethodResponse;
    },
  ) {}

  onCancel(): void {
    this.dialogRef.close({ cancel: true });
  }

  onRemove(): void {
    this.paypointService
      .removePaymentMethod(
        this.data.organization,
        this.data.customerId,
        this.data.method.payment_method_code,
      )
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
          this.layoutUtility.showActionNotification(
            'SUCCESS',
            'Payment method removed successfully',
          );
          if (this.data.newDefaultCardSelected) {
            this.paypointService
              .setDefaultPaymentMethod(
                this.data.organization,
                this.data.customerId,
                this.data.newDefaultCardSelected.payment_method_code,
              )
              .subscribe({
                next: () => {
                  setTimeout(() => {
                    this.layoutUtility.showActionNotification(
                      'SUCCESS',
                      'Primary payment method changed successfully',
                    );
                  }, 2000);
                },
              });
          }
        },
        error: () => {
          this.dialogRef.close({ success: false });
          this.layoutUtility.showActionNotification('ERROR', 'Something went wrong!');
        },
      });
  }

  getMaskedNumber(method: PaymentMethodResponse): string {
    if (method.type === 'card') {
      return `(•••• •••• •••• ${method.token_data.data.card?.last4})`;
    }
    if (method.type === 'ach') {
      return `(•••• •••• •••• ${method.token_data.data.bank?.account_number_last4})`;
    }
  }
}
